// extracted by mini-css-extract-plugin
module.exports = {"lcResources":"lcResources_lcResources__1oF1M","title":"lcResources_title__2hcEb","articles":"lcResources_articles__4RrTw"};